export type StatusTone = 'ok' | 'warn' | 'bad' | 'neutral';

const OK_STATUSES = new Set(['active', 'available', 'busy', 'connected', 'healthy', 'idle', 'ready', 'running']);

const WARN_STATUSES = new Set([
    'degraded',
    'deleting',
    'pending',
    'provisioning',
    'pulling',
    'scaling',
    'scaling_down',
    'starting',
    'submitted',
    'terminating',
    'updating',
    'waiting',
]);

const BAD_STATUSES = new Set(['error', 'failed', 'unavailable', 'unhealthy', 'unreachable']);

export function statusTone(status: string): StatusTone {
    const normalized = status.trim().toLowerCase();
    if (OK_STATUSES.has(normalized)) return 'ok';
    if (WARN_STATUSES.has(normalized)) return 'warn';
    if (BAD_STATUSES.has(normalized)) return 'bad';
    return 'neutral';
}
